import { FC } from 'react';
import Image from 'next/image';
import { IPopularCollection } from '@modules/collections/domain/models/popularCollection.model';
import { analytics } from '@shared/utils/segment.utils';
import { Container, MenuAmount, Name, RecipeImgWrapper, RecipeItem, Title } from './PopularCollectionCard.style';
const PopularCollectionCard: FC<IPopularCollection> = ({
  menuAmount,
  menuAmountColor,
  name,
  nameColor,
  backgroundImage,
  recipeList
}: IPopularCollection) => {
  const onClickTracker = (recipeName: string) => {
    analytics.track('Popular Collection Recipe Click', {
      event: 'Popular Collection Recipe Click',
      recipe_name: recipeName,
      collection_name: name
    });
    analytics.track('Recipe Viewed', {
      event: 'Recipe Viewed',
      recipe_name: recipeName,
      ingredient: ''
    });
  };
  return <Container $backgroundImg={backgroundImage}>
            <Title>
                <MenuAmount $textColor={menuAmountColor}>
                    {menuAmount} เมนู
                </MenuAmount>
                <Name $textColor={nameColor}>{name}</Name>
            </Title>
            <RecipeImgWrapper>
                {recipeList.map(recipeItem => <RecipeItem key={recipeItem.id} href={`/recipe/${recipeItem.slug}`} onClick={() => onClickTracker(recipeItem.name)}>
                        <Image src={recipeItem.imageUrl || '/images/default/recipe.jpg'} alt={name} onError={({
          currentTarget
        }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = '/images/default/recipe.jpg';
        }} loading="lazy" placeholder="blur" blurDataURL="/images/default/recipe.jpg" width={172} height={172} />
                    </RecipeItem>)}
            </RecipeImgWrapper>
        </Container>;
};
export default PopularCollectionCard;